import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme, type ThemePreference } from '@/hooks/useTheme';
import { cn } from '@/lib/utils';

const OPTIONS: Array<{ value: ThemePreference; icon: typeof Sun; labelKey: string }> = [
  { value: 'light', icon: Sun, labelKey: 'common.themeLight' },
  { value: 'dark', icon: Moon, labelKey: 'common.themeDark' },
  { value: 'system', icon: Monitor, labelKey: 'common.themeSystem' },
];

export function ThemeToggle({ className }: { className?: string }) {
  const { preference, setPreference } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      role="group"
      aria-label={t('common.theme')}
      className={cn('inline-flex items-center gap-0.5 rounded-xl border border-border bg-surface p-0.5', className)}
    >
      {OPTIONS.map(({ value, icon: Icon, labelKey }) => (
        <button
          key={value}
          type="button"
          onClick={() => setPreference(value)}
          aria-pressed={preference === value}
          title={t(labelKey)}
          aria-label={t(labelKey)}
          className={cn(
            'rounded-lg p-1.5 transition-colors',
            preference === value ? 'bg-primary text-primary-ink' : 'text-ink-muted hover:bg-surface-muted hover:text-ink',
          )}
        >
          <Icon className="h-4 w-4" aria-hidden />
        </button>
      ))}
    </div>
  );
}
